import { gql } from "@apollo/client";

export const INVITE_USERS_TO_TEAM = gql`
  mutation InviteUsersToTeam(
    $inviteUsersToTeamInput: InviteUsersToTeamInput!
  ) {
    inviteUsersToTeam(
      inviteUsersToTeamInput: $inviteUsersToTeamInput
    ) {
      provisionedUsers {
        existing {
          inviteUuid
          success
          email
          reason
        }
        newUsers {
          inviteUuid
          success
          email
          reason
        }
      }
    }
  }
`;
